export class AddSingleFormatToCartModel {
    public format: string = "";
    public quantity: number = 1;

    public constructor(
        public productId: number
    ) {

    }
}
